export interface CaseActivityId {
    caseId: number;
    activityId: number;
}

// Temporary stand-in for the case API (still in development). Real incident-report API
// calls reject the randomly generated ids the referralId hex-parsing trick used to produce,
// so this is a real caseId/activityId pairing pulled from GraphQL, matched to referrals by
// array position until the case API can supply these values itself.
export const CASE_ACTIVITY_IDS: CaseActivityId[] = [
    { activityId: 9391178, caseId: 7568201 },
    { activityId: 9391181, caseId: 7568203 },
    { activityId: 9391182, caseId: 7568204 },
    { activityId: 9391185, caseId: 7568206 },
    { activityId: 9391203, caseId: 7568222 },
    { activityId: 9391205, caseId: 7568223 },
    { activityId: 9391211, caseId: 7568227 },
    { activityId: 9391207, caseId: 7568224 },
    { activityId: 9391218, caseId: 7568232 },
    { activityId: 9391219, caseId: 7568233 },
    { activityId: 9391220, caseId: 7568234 },
    { activityId: 9391225, caseId: 7568239 },
    { activityId: 9391228, caseId: 7568242 },
    { activityId: 9391239, caseId: 7568249 },
    { activityId: 9391238, caseId: 7568248 },
    { activityId: 9391240, caseId: 7568250 },
    { activityId: 9391241, caseId: 7568251 },
    { activityId: 9391242, caseId: 7568252 },
    { activityId: 9391243, caseId: 7568253 },
    { activityId: 9391244, caseId: 7568254 },
    { activityId: 9391252, caseId: 7568261 },
    { activityId: 9391272, caseId: 7568278 },
    { activityId: 9391273, caseId: 7568279 },
    { activityId: 9391275, caseId: 7568280 },
    { activityId: 9391288, caseId: 7568291 },
    { activityId: 9391293, caseId: 7568295 },
    { activityId: 9391294, caseId: 7568296 },
    { activityId: 9391297, caseId: 7568299 },
    { activityId: 9391298, caseId: 7568300 },
    { activityId: 9391307, caseId: 7568307 },
    { activityId: 9391320, caseId: 7568319 },
    { activityId: 9391321, caseId: 7568320 },
    { activityId: 9391322, caseId: 7568321 },
    { activityId: 9391325, caseId: 7568323 },
    { activityId: 9391326, caseId: 7568324 },
    { activityId: 9391328, caseId: 7568325 },
    { activityId: 9391346, caseId: 7568326 },
    { activityId: 9391330, caseId: 7568327 },
    { activityId: 9391336, caseId: 7568331 },
    { activityId: 9391338, caseId: 7568332 },
    { activityId: 9391339, caseId: 7568333 },
    { activityId: 9391340, caseId: 7568334 },
    { activityId: 9391342, caseId: 7568336 },
    { activityId: 9391347, caseId: 7568340 },
    { activityId: 9391350, caseId: 7568343 },
    { activityId: 9391356, caseId: 7568349 },
    { activityId: 9391370, caseId: 7568362 },
    { activityId: 9391373, caseId: 7568365 },
    { activityId: 9391384, caseId: 7568375 },
    { activityId: 9391394, caseId: 7568384 },
    { activityId: 9391401, caseId: 7568389 },
    { activityId: 9391406, caseId: 7568393 },
    { activityId: 9391408, caseId: 7568394 },
    { activityId: 9391410, caseId: 7568395 },
    { activityId: 9391412, caseId: 7568396 },
    { activityId: 9393013, caseId: 7569774 },
    { activityId: 9393012, caseId: 7569775 },
    { activityId: 9391474, caseId: 7568436 },
    { activityId: 9391477, caseId: 7568435 },
    { activityId: 9391479, caseId: 7568434 },
    { activityId: 9391475, caseId: 7568437 },
    { activityId: 9391584, caseId: 7568527 },
    { activityId: 9391589, caseId: 7568529 },
    { activityId: 9391592, caseId: 7568532 },
    { activityId: 9391420, caseId: 7568401 },
    { activityId: 9391438, caseId: 7568417 },
    { activityId: 9391495, caseId: 7568458 },
    { activityId: 9391480, caseId: 7568446 },
    { activityId: 9391414, caseId: 7568397 },
    { activityId: 9391416, caseId: 7568398 },
    { activityId: 9391512, caseId: 7568403 },
    { activityId: 9391427, caseId: 7568406 },
    { activityId: 9391439, caseId: 7568418 },
    { activityId: 9391498, caseId: 7568459 },
    { activityId: 9391489, caseId: 7568452 },
    { activityId: 9391470, caseId: 7568442 },
    { activityId: 9391499, caseId: 7568460 },
    { activityId: 9391500, caseId: 7568461 },
    { activityId: 9391530, caseId: 7568484 },
    { activityId: 9391564, caseId: 7568511 },
    { activityId: 9391568, caseId: 7568515 },
    { activityId: 9391569, caseId: 7568516 },
    { activityId: 9391570, caseId: 7568517 },
    { activityId: 9391571, caseId: 7568518 },
    { activityId: 9391599, caseId: 7568536 },
    { activityId: 9392885, caseId: 7569668 },
    { activityId: 9392905, caseId: 7569683 },
    { activityId: 9391578, caseId: 7568522 },
    { activityId: 9391579, caseId: 7568523 },
];
